// Component adapted from a demo on the `next` branch of material-ui
// https://github.com/callemall/material-ui/blob/next/docs/site/src/demos/tables/EnhancedTable.js
import React, { Component } from 'react';
import { WithStyles, withStyles, createStyles, Theme } from '@material-ui/core';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import { Typography } from 'embeds/components';

const styles = (theme: Theme) =>
  createStyles({
    sortLabel: {
      color: theme.palette.common.black,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.custom.fontSizes.tiny,
    },
    head: {
      background: theme.palette.common.white,
      color: theme.palette.common.black,
    },
  });

export enum Order {
  DESC = 'desc',
  ASC = 'asc',
}

export type Column = {
  id: string;
  label: string;
  numeric?: boolean;
  disableSort?: boolean;
  padding?: 'none' | 'checkbox' | 'default';
  style?: Record<string, unknown>;
  sort?: (data?: unknown[], order?: 'desc' | 'asc') => unknown;
};

export interface EnhancedTableHeadProps extends WithStyles<typeof styles> {
  columnData: Column[];
  columnStyle?: Record<string, unknown>;
  onRequestSort?: (event: unknown, property: string) => void;
  order: Order;
  orderBy?: string;
  selectable?: boolean;
  disableSort?: boolean;
}

class EnhancedTableHead extends Component<EnhancedTableHeadProps> {
  createSortHandler = (property: string) => (event: unknown) => this.props.onRequestSort!(event, property);

  getColumnStyle(column: Column) {
    // width from column config
    const { style } = column;
    if (style) {
      return style;
    }
    const { id } = column;
    if (/^checkbox|id$/.test(id)) {
      return { width: 50 };
    }
    if (/^lastUpdated$/.test(id)) {
      return { width: 100 };
    }

    const { columnStyle } = this.props;
    return columnStyle ? columnStyle[id] : { width: 'initial' };
  }

  render() {
    const { classes, columnData, order, orderBy, disableSort } = this.props;

    return (
      <TableHead className={classes.head}>
        <TableRow style={{ height: 48 }}>
          {this.renderCellSelect()}
          {columnData.map((column) => (
            <TableCell
              classes={{ root: classes.sortLabel }}
              // @ts-ignore
              style={this.getColumnStyle(column)}
              key={column.id}
              align={column.numeric ? 'right' : 'inherit'}
              padding={column.padding || 'dense'}
            >
              {disableSort || column.disableSort ? (
                <Typography className={classes.sortLabel}>{column.label ? column.label.toUpperCase() : ''}</Typography>
              ) : (
                <TableSortLabel
                  className={classes.sortLabel}
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                >
                  <Typography className={classes.sortLabel}>
                    {column.label ? column.label.toUpperCase() : ''}
                  </Typography>
                </TableSortLabel>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderCellSelect() {
    const { selectable } = this.props;

    if (!selectable) return;

    // @ts-ignore
    return <TableCell style={{ width: 48 }} checkbox="true" />;
  }
}

export default withStyles(styles)(EnhancedTableHead);
